 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781416593218_COV from '@/components/9781416593218_cov'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import A781416593218_COL from '@/components/9781416593218_col'
 import A781416593218_TITLEPAGE_01 from '@/components/9781416593218_titlePage_01'
 import A781416593218_CRP from '@/components/9781416593218_crp'
 import A781416593218_DED from '@/components/9781416593218_ded'
 import A781416593218_ACK from '@/components/9781416593218_ack'
 import A781416593218_CON from '@/components/9781416593218_con'
 import A781416593218_HALFTITLEPAGE_01 from '@/components/9781416593218_halfTitlePage_01'
 import A781416593218_PRO from '@/components/9781416593218_Pro'
 import A781416593218_CH01 from '@/components/9781416593218_Ch01'
 import A781416593218_CH02 from '@/components/9781416593218_Ch02'
 import A781416593218_CH03 from '@/components/9781416593218_Ch03'
 import A781416593218_CH04 from '@/components/9781416593218_Ch04'
 import A781416593218_CH05 from '@/components/9781416593218_Ch05'
 import A781416593218_CH06 from '@/components/9781416593218_Ch06'
 import A781416593218_CH07 from '@/components/9781416593218_Ch07'
 import A781416593218_CH08 from '@/components/9781416593218_Ch08'
 import A781416593218_CH09 from '@/components/9781416593218_Ch09'
 import A781416593218_CH10 from '@/components/9781416593218_Ch10'
 import A781416593218_CH11 from '@/components/9781416593218_Ch11'
 import A781416593218_CH12 from '@/components/9781416593218_Ch12'
 import A781416593218_CH13 from '@/components/9781416593218_Ch13'
 import A781416593218_CH14 from '@/components/9781416593218_Ch14'
 import A781416593218_CH15 from '@/components/9781416593218_Ch15'
 import A781416593218_CH16 from '@/components/9781416593218_Ch16'
 import A781416593218_CH17 from '@/components/9781416593218_Ch17'
 import A781416593218_CH18 from '@/components/9781416593218_Ch18'
 import A781416593218_CH19 from '@/components/9781416593218_Ch19'
 import A781416593218_CH20 from '@/components/9781416593218_Ch20'
 import A781416593218_CH21 from '@/components/9781416593218_Ch21'
 import A781416593218_CH22 from '@/components/9781416593218_Ch22'
 import A781416593218_CH23 from '@/components/9781416593218_Ch23'
 import A781416593218_EPI from '@/components/9781416593218_Epi'
 import A781416593218_ATA from '@/components/9781416593218_ata'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9781416593218_con",
 			"name" : "9781416593218_con",
 			"component" : A781416593218_CON
 		},
 		{
 			"path" : "/9781416593218_halfTitlePage_01",
 			"name" : "9781416593218_halfTitlePage_01",
 			"component" : A781416593218_HALFTITLEPAGE_01
 		},
 		{
 			"path" : "/9781416593218_Pro",
 			"name" : "9781416593218_Pro",
 			"component" : A781416593218_PRO
 		},
 		{
 			"path" : "/9781416593218_Ch01",
 			"name" : "9781416593218_Ch01",
 			"component" : A781416593218_CH01
 		},
 		{
 			"path" : "/9781416593218_Ch02",
 			"name" : "9781416593218_Ch02",
 			"component" : A781416593218_CH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js